module.exports = __webpack_public_path__ + "img/symbol_4.fa5efc66.png";